import { render } from "./ResetPasswordLinkComponent.vue?vue&type=template&id=9fc3e7fe&ts=true"
import script from "./ResetPasswordLinkComponent.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordLinkComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__